let snackbarTimeout = null;

export const ShowSnackbar = (contents) => {
    const bar = document.getElementById("snackbar");

    // Clear any existing timeout so rapid calls don't interfere.
    if (snackbarTimeout) {
        clearTimeout(snackbarTimeout);
    }

    bar.classList.add("show");
    bar.innerHTML = contents;

    // After 3 seconds, remove the show class from DIV.
    snackbarTimeout = setTimeout(() => {
        bar.classList.remove("show");
        snackbarTimeout = null;
    }, 3000);
};

export const ShowProposalSubmitting = () => ShowSnackbar("Thank you, your proposal is submitting...");
export const ShowProposalSuccess = () => ShowSnackbar("Thank you for your proposal!");

export default ShowSnackbar;
